import type { ReportFilters } from './api'

/** Copy active filters without paging state; dates retain the selected local day. */
export function reportFilters(filters: object): ReportFilters {
  const result: ReportFilters = {}
  for (const [key, value] of Object.entries(filters)) {
    if (['page', 'page_size', 'cursor', 'sort', 'ordering'].includes(key))
      continue
    if (value instanceof Date) {
      if (!Number.isNaN(value.getTime()))
        result[key] = `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
    }
    else if (Array.isArray(value) && value.length && value.every(item => typeof item === 'string' || typeof item === 'number'))
      result[key] = [...value]
    else if (typeof value === 'boolean' || typeof value === 'number' || (typeof value === 'string' && value !== ''))
      result[key] = value
  }
  return result
}
